/**
 * расположение встраиваемого видео-контента
 *
 * center - центральная часть приложения
 * user - пользователь в списке участников
 * */
export type TLocation = 'center' | 'user';

/** Получить строку с ID для DOM элемента, в который будет встраиваться видео-контент */
export function getVideoContainerId({ id, location }: { id: string; location: TLocation }) {
    return `remote-video-${location}-${id}`;
}
